import React, { useEffect, useState } from "react";
import { Col, Input, Popover, Radio, Row, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import LoanTabDatas from "./LoanTabsData";
import "../../assets/Custom.css";
import SwitchBox from "./SwitchBox";
import SortBy from "./SortBy";
import axios from "../../helpers/axios";
import LoanSwitchBoxList from "./LoanSwitchBoxList";
import PageLoader from "../../components/PageLoader";
import { useDispatch, useSelector } from "react-redux";
import { setLogHistoryFilter } from "../../redux/slice/adminNotificationSlice";
import { DuplicateCheck } from "../../helpers/constants";

const LogHistory = () => {
    const dispatch = useDispatch();
    const LogHistoryFilters = useSelector(
        (state) => state.adminNotificationFilter?.LogHistoryFilters
    );
    //console.log("LogHistoryFilters", LogHistoryFilters);
    const [size, setSize] = useState("small");
    const [loading, setLoading] = useState(false);
    const [listDetails, setListDetails] = useState([]);
    const [tabIndex, settabIndex] = useState(0);
    const [tabTitle, settabTitle] = useState("1");
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 20,
        apiCall: true,
        total: 0
    });
    //console.log("tabIndex", tabIndex)
    // Object.keys(LogHistoryFilters)?.length > 0 ? LogHistoryFilters?.filter :

    const [loanDetailName, setLoanDetailName] = useState("");
    const [searchText, setSearchText] = useState("");
    const { TabPane } = Tabs;
    const onChange = (e) => {
        setSize(e.target.value);
    };
    const [applyFilters, setApplyFilters] = useState(
        LogHistoryFilters !== undefined && LogHistoryFilters !== null && Object.keys(LogHistoryFilters)?.length > 0
            ? LogHistoryFilters
            : {
                keyword: "",
                sortKey: "created_at",
                sortOrder: "today",
                index: 0,
                "item_type": "product",
                provider_type: "all",
            }
    );

    const LoanCaseList = async () => {

        const resp = await axios.post(
            `/admin/update/log/list/100/${pagination.page}`,
            {
                ...applyFilters,
                provider_type:
                    applyFilters?.provider_type === "all"
                        ? ""
                        : applyFilters?.provider_type,
            }
        );
        if (resp.status < 400 && resp.data?.data?.length > 0) {
            setPagination({
                ...pagination,
                total: resp.data.total
            })
            const temp = resp.data?.data?.map((it, index) => {
                return {
                    ...it,
                    id: `LOH${index + 1}`,
                    productID: it?.lt?.after_update?.product,
                };
            });

            const newArray = temp.flatMap((obj, index) => [
                {
                    date_time: obj?.date_time,
                    provider: obj?.provider,
                    product: obj?.product,
                    interest: obj?.lt,
                    type: "LT"
                },
                {
                    date_time: obj?.date_time,
                    provider: obj?.provider,
                    product: obj?.product,
                    interest: obj?.ht,
                    type: "HT"
                },
            ]);
            const GetFilterArray = (arr) => {
                const results = arr.filter((element) => {
                    if (Object.keys(element).length !== 0) {
                        return true;
                    }

                    return false;
                });
                return results;
            };
            const filtered = newArray?.filter((it) => GetFilterArray(Object.values(it?.interest))?.length > 0)
            setListDetails(filtered);
        } else {
            setListDetails([]);
        }

    };

    const handleSortBy = (val) => {
        //console.log("VALUE", val);
        switch (val) {
            case "Recent":
                setApplyFilters({
                    ...applyFilters,
                    sortKey: "created_at",
                    sortOrder: "today",
                });
                dispatch(
                    setLogHistoryFilter({
                        ...applyFilters,
                        sortKey: "created_at",
                        sortOrder: "today",
                    })
                );
                break;
            case "Last 7 Days":
                setApplyFilters({
                    ...applyFilters,
                    sortKey: "created_at",
                    sortOrder: "lastweek",
                });
                dispatch(
                    setLogHistoryFilter({
                        ...applyFilters,
                        sortKey: "created_at",
                        sortOrder: "lastweek",
                    })
                );

                break;
            case "Last 1 Month":
                setApplyFilters({
                    ...applyFilters,
                    sortKey: "created_at",
                    sortOrder: "lastmonth",
                });
                dispatch(
                    setLogHistoryFilter({
                        ...applyFilters,
                        sortKey: "created_at",
                        sortOrder: "lastmonth",
                    })
                );
                break;
            case "Last 6 Months":
                setApplyFilters({
                    ...applyFilters,
                    sortKey: "created_at",
                    sortOrder: "last6months",
                });
                dispatch(
                    setLogHistoryFilter({
                        ...applyFilters,
                        sortKey: "created_at",
                        sortOrder: "last6months",
                    })
                );
                break;
            default:
                break;
        }
    };

    const hadlePagination = (val) => {
        if (val?.current > pagination?.page) {
            setPagination({
                page: val?.current,
                pageSize: val?.pageSize,
                apiCall: true
            })
        } else {
            setPagination({
                page: val?.current,
                pageSize: val?.pageSize,
                apiCall: false
            })
        }

    }

    //console.log("listDetails", listDetails);


    const items = [
        {
            label: "Update",
            key: "product",
            children: <LoanTabDatas data={listDetails} type={"pending"} tabIndex={tabIndex} pagination={pagination} hadlePagination={hadlePagination} />,
        },
        {
            label: "Schedule",
            key: "schedule",
            children: <LoanTabDatas data={listDetails} type={"disbursement"} tabIndex={tabIndex} pagination={pagination} hadlePagination={hadlePagination} />,
        },
        {
            label: "Dealer Comm.",
            key: "dealercomm",
            children: <LoanTabDatas data={listDetails} type={"expired"} tabIndex={tabIndex} pagination={pagination} hadlePagination={hadlePagination} />,
        },
    ];



    useEffect(() => {
        setApplyFilters({ ...applyFilters, filter: tabTitle, index: tabIndex });
        dispatch(
            setLogHistoryFilter({
                ...applyFilters,
                filter: tabTitle,
                index: tabIndex,
            })
        );
    }, [tabTitle]);

    useEffect(() => {
        setApplyFilters({ ...applyFilters, provider_type: loanDetailName });
        dispatch(
            setLogHistoryFilter({
                ...applyFilters,
                provider_type: loanDetailName,
            })
        );
    }, [loanDetailName]);

    useEffect(() => {
        setApplyFilters({ ...applyFilters, keyword: searchText });
        dispatch(setLogHistoryFilter({ ...applyFilters, keyword: searchText }));
    }, [searchText]);

    useEffect(() => {
        LoanCaseList();
    }, []);
    useEffect(() => {
        LoanCaseList();
    }, [applyFilters]);


    //console.log("LISTDETAILS", listDetails);

    if (loading) {
        return <PageLoader />;
    }

    return (
        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-x-clip">
            <div className="bg-white">
                <Row gutter={[24, 24]} className="p-[18px_25px]">
                    <Col xs={24} sm={24} md={16} lg={15}>
                        <div className="text-[18px] font-[700] bg-white">Log History</div>
                    </Col>
                    <Col xs={24} sm={24} md={9} lg={9}>
                        <Row gutter={[24, 24]}>
                            <Col xs={12} sm={24} md={16} lg={16}>
                                <div className="">
                                    <div className="absolute h-[100%] left-[15px] flex items-center max-[768px]:left-[18px] max-[768px]:top-[-2px]">
                                        <img
                                            src="/images/search.svg"
                                            alt="search"
                                            className="pt-[3px]"
                                        />
                                    </div>
                                    <input
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                        }}
                                        type="search"
                                        placeholder="Search Loan Provider, product…"
                                        className="pl-[25px] outline-none text-[13px]  max-[768px]:border max-[768px]:border-gray-200 max-[768px]:p-[8px_20px_8px_33px] max-[768px]:rounded-[5px] max-[600px]:w-[calc(100%-50px)]"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div className="mx-5">
                    <LoanSwitchBoxList
                        activeTabId={applyFilters.provider_type}
                        handler={setLoanDetailName}
                        tabs={[
                            { name: "All", dataKey: "All", id: "all" },
                            {
                                name: "Bank",
                                dataKey: "Bank",
                                id: "08469bdc-7b03-4f3f-8b34-7cc71d048640",
                            },
                            {
                                name: "Financial Institution",
                                dataKey: "Financial_Institution",
                                id: "0bdb91a1-edca-4ec4-b298-30c431f38c2d",
                            },
                            {
                                name: "In-House",
                                dataKey: "In-House",
                                id: "eea49ff4-655f-412e-8bb2-22e0cf8578db",
                            },
                        ]}
                    />
                </div>
                <div className="app-container p-[10px_25px]">
                    <Tabs
                        defaultActiveKey={tabTitle}
                        activeKey={applyFilters?.item_type}
                        onChange={(value) => {
                            setApplyFilters({
                                ...applyFilters,
                                item_type: value
                            });
                            dispatch(
                                setLogHistoryFilter({
                                    ...applyFilters,
                                    item_type: value
                                })
                            );
                            settabTitle(value);
                            settabIndex(value - 1);
                        }}
                        items={items}
                        tabBarExtraContent={
                            <div className="sort-container">
                                <SortBy handleSortBy={handleSortBy} value={applyFilters?.sortOrder} />
                            </div>
                        }
                    ></Tabs>
                </div>
            </div>
        </div>
    );
};

export default LogHistory;
